export default {
  '.MuiOutlinedInput-notchedOutline': {
    border: '1px solid #FFA000',
    borderRadius: '4px',
    '&:focus': {
      borderColor: '#0528A0'
    }
  }
};
